import { splitLines } from '../detect.js';
const TITLE_RE = /^\s*title\s+(.+)$/i;
const SECTION_RE = /^\s*section\s+(.+)$/i;
const TASK_RE = /^\s*(\S[^:]*?)\s*(?::\s*(\S+)\s*,\s*(\S+)\s*(?:,\s*(\S+)\s*)?)?:\s*(\S+)\s*$/;
export const parseGantt = (source) => {
    const lines = splitLines(source);
    const nodes = [];
    const edges = [];
    const groups = [];
    const tasks = [];
    let title;
    let currentSection = '';
    for (const raw of lines) {
        const line = raw.trim();
        if (!line || /^gantt\b/i.test(line))
            continue;
        const t = TITLE_RE.exec(line);
        if (t) {
            title = t[1]?.trim();
            continue;
        }
        const s = SECTION_RE.exec(line);
        if (s) {
            currentSection = s[1].trim();
            groups.push({ id: `sec_${slug(currentSection)}`, label: currentSection, members: [] });
            continue;
        }
        const task = TASK_RE.exec(line);
        if (task) {
            const [, label, a, b, c, status] = task;
            const id = `t_${slug(label ?? '')}_${tasks.length}`;
            tasks.push({
                id,
                label: (label ?? '').trim(),
                section: currentSection,
                start: a,
                duration: b,
                end: c,
            });
            nodes.push({
                id,
                label: `${(label ?? '').trim()}${status ? ` (${status})` : ''}`,
                shape: 'rect',
                parent: `sec_${slug(currentSection)}`,
            });
            const group = groups.find((g) => g.id === `sec_${slug(currentSection)}`);
            if (group)
                group.members.push(id);
        }
    }
    return {
        type: 'gantt',
        title,
        nodes,
        edges,
        groups,
        styles: {},
        meta: { tasks },
    };
};
const slug = (s) => s.replace(/[^a-zA-Z0-9_]/g, '_');
//# sourceMappingURL=gantt.js.map